<template>
  <div v-if="messages.length" class="verticalIconMessageContainer" :class="{grayBackground}">
    <div class="container">
      <h4 v-if="title" class="text-center">{{ title }}</h4>
      <div class="listWrapper flex-col-start-center">
        <div
          v-for="(
            {
              icon,
              iconColor,
              iconBgColor,
              title,
              message
            }, index
          ) in messages"
          :key="index"
          class="iconMessage text-left mb-4 flex-center"
        >
          <div class="iconWrapper flex-center text-left" :style="`background:${iconBgColor}`">
            <component v-bind:is="icon" :fill="iconColor" height="40px" width="40px" />
          </div>
          <div class="messageContentWrapper py-2">
            <div class="titleWrapper">
              <span v-for="text in title" :key="text">
                {{ text }}
              </span>
            </div>
            <p v-html="message" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VerticalIconMessage',
  props: {
    title: {
      type: String,
      required: false
    },
    grayBackground: {
      type: Boolean,
      required: false,
      default: true
    },
    messages: {
      type: Array,
      required: true,
    }
  }
};
</script>

<style lang="scss">
  @import '@sass/vue-imports.scss';

  .verticalIconMessageContainer {
    padding: 100px 0;
    &.grayBackground {
      background: $brand-lighter;
    }
    @include media-breakpoint-down(sm) {
      padding: 35px 0 5px;
    }

    h4 {
      margin-bottom: 100px;
      @include media-breakpoint-down(sm) {
        margin-bottom: 35px;
      }
    }

    .listWrapper {
      max-width: 900px;
      margin: 0 auto;
      width: fit-content;

      .iconMessage {
        display: flex;

        @include media-breakpoint-down(sm) {
          flex-direction: column;
          width: 100%;
          &:not(:last-of-type) {
            border-bottom: 1px solid $silver;
          }
        }

        .messageContentWrapper {
          margin-left: 16px;
          padding-left: 16px;
          border-left: 1px solid $silver;
          @include media-breakpoint-down(sm) {
            border-left: none;
            margin: 16px 0 10px;
            text-align: center !important;
            padding-left: 0;
            padding-bottom: 16px;
          }
        }

        .titleWrapper {
          >span {
            text-align: center;
            font-weight: 900;
            letter-spacing: 0.02em;
            text-transform: uppercase;
            color: $dark-gray;
          }
        }

        .iconWrapper {
          height: 70px;
          width: 70px;
          min-width: 70px;
          border-top-left-radius: 10px;
          border-bottom-right-radius: 10px;
          @include media-breakpoint-down(sm) {
            margin: 0 auto;
          }
        }

        p {
          margin: 0;
        }
      }
    }
  }
</style>